<template>
  <div id="ContractEquipmentAsAt">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Contract Equipment Listing As At</div>
          <div class="web-action-btn btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'contractEquipmentAsAt'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'contractEquipmentAsAt'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                      mode="remote"
                      ref="contractEquipmentAsAtTable"
                      title="contractEquipmentAsAt"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      @on-select-all="onSelectAll"
                      @on-selected-rows-change="selectionChanged"
                      :totalRows="totalRecords"
                      :columns="userColumns"
                      :rows="rows"
                      :paginationOptions="{
                          enabled: false,
                          position: 'both',
                          perPage: perPage,
                          dropdownAllowAll: false,
                          setCurrentPage:listCurrentPage,
                          perPageDropdown:dropDownPerPage,
                      }"
                      :select-options="{
                          enabled: false,
                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                          selectionInfoClass: 'custom-class',
                          selectionText: 'rows selected',
                          clearSelectionText: 'clear',
                      }"
                      :search-options="{
                      enabled: false,
                      }"

                >
                </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
            <div class="bg-white text-center">
                <h1>
                    Oops!</h1>
                <h2>
                    403 </h2>
                <div class="error-details">
                    Sorry!, You don't have permission to access this page.
                </div>
            </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
  import Vue from "vue";
  
  
  
  
  
  import {commonMixins} from '../../mixins/commonMixins';
  import {dataTableMixins} from '../../mixins/dataTableMixins';
  export default {
    name: "ContractEquipmentListingAsAt",
    metaInfo(){
        return {
          title : 'Contract Equipment Listing As At | FleetPro Application'
        }
      },
    mixins: [commonMixins,dataTableMixins],
    data: () => ({
      cantAccessPage:"",
      loading: false,
      action: '',
      permissions:[],
      rows: [],
      totalRecords: 0,
      userColumns:[],
      columns:[
          {
              label: 'Salesman Name',
              field: 'sales_person',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: "Equipment Pool Assign",
              field: "pool",
              filterable: true,
              fpFieldType:"option",
              hidden:false,
          },
          {
              label: 'Unit Number',
              field: 'unit_no',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: "Facility Code",
              field: "location",
              filterable: true,
              fpFieldType:"option",
              hidden:false,
          },
          {
              label: 'Agreement Type',
              field: 'agreement_type',
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'Agreement Number',
              field: 'agreement_no',
              hidden:false,
              filterable: true,
              fpFieldType:"text"
          },
          {
              label: 'Agreement Term',
              field: 'agreement_term',
              sortable: false,
              hidden:false,
              filterable: false,
              fpFieldType:"text"
          },
          {
              label: 'Effective Date',
              field: 'effective_date',
              hidden:false,
              fpFieldType:"custom_date",
              filterable: true
          },
          {
              label: 'Expiry Date',
              field: 'expiry_date',
              hidden:false,
              fpFieldType:"custom_date",
              filterable: true
          },
          {
              label: 'Term Date',
              field: 'term_date',
              hidden:false,
              fpFieldType:"custom_date",
              filterable: false,
              sortable: false,
          },
          {
              label: 'Customer Name',
              field: 'cust_name',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: 'Equipment Type',
              field: 'equip_type',
              hidden:false,
              filterable: true,
              fpFieldType:"option",
          },
          {
              label: 'Equip Type Desc',
              field: 'equip_type_desc',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: 'Make',
              field: 'manu_code',
              hidden:false,
              filterable: true,
              fpFieldType:"text",
          },
          {
              label: 'Unit Year',
              field: 'year',
              hidden:false,
              filterable: true,
              fpFieldType:"text",
          },
          {
              label: 'As At Date',
              field: 'as_at_date',
              filterable: false,
              hidden:true,
              fpFieldType:"custom_date",
              sortable:false
          },

      ],
      batchProcess:0,
      batchNum:"",
    }),
    watch:{
      permissions: function(permission) {
          var self = this;
          permission.forEach(function (permissions) {
              if(permissions.name == 'contract_equipment_as_at') {
                  self.cantAccessPage = true;
              }
          });
          if(self.cantAccessPage == ''){
              self.cantAccessPage = false;
          }
      },
    },
    mounted: function(){
      var self = this;
      self.getPermissions();
    },
    methods:{
      loadList: function(){

        var self = this;
        var asOfDate = "";

        if (self.serverParams.columnFilters.length > 0) {
                for(var i = 0;i < self.serverParams.columnFilters.length;i++) {
                    if (self.serverParams.columnFilters[i] != undefined) {
                        if (self.serverParams.columnFilters[i] != null) {
                            if (self.serverParams.columnFilters[i].columnId != null) {
                                if (self.serverParams.columnFilters[i].columnId.field != null) {
                                  if (self.serverParams.columnFilters[i].columnId.field == "as_at_date") {
                                        asOfDate = self.serverParams.columnFilters[i].filterValue;
                                    }
                                }
                            }
                        }
                    }
                }
          }
          if(asOfDate == "" || asOfDate == null){
            return;
          }
          self.loading = true;
          $.ajax({
              url: process.env.ROOT_API + "/contract-equipment-as-at-report/list",
              type: "POST",
              crossDomain: true,
              headers: this.ajxHeaders,
              dataType: "json",
              data: {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: this.serverParams.columnFilters,
                sort: this.serverParams.sort,
                action: self.action,
                asOfDate:asOfDate,
              },
              success: function(data) {
                self.loading = false;
                //console.log(data.content[0]["id"]);
                  if (data.status == "success") {

                    if ( self.action == "export" ||  self.action == "export_queue") {

                        if ( data.code == "201" ) {
                            alert(data.message);
                        } else {

                            if ( self.action == "export" ) {

                                self.excel = data.content.web;
                                var save = document.createElement("a");
                                save.href = self.excel;
                                save.download = data.content.web;
                                save.target = "_blank";

                                document.body.appendChild(save);
                                save.click();
                                document.body.removeChild(save);

                            } else {

                                self.batchProcess = 1;
                                self.batchNum = data.content;
                            }

                        }

                        self.action = "list";
                        // self.loadList();
                        return;
                    } else {
                      if (data.content.row != undefined) {
                        self.rows = data.content.row;
                      }
                      self.totalRecords = data.content.totalRecords;
                    }
                  }
              },
              error: function(jqXHR, exception) {
                self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,true,'equipment-current-status')
              }
            });


      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/reports/ContractEquipmentAsAt.vue